var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3701_7106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3701_7106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 19.9998C10.7165 19.9998 10.479 19.9039 10.2873 19.7123C10.0957 19.5206 9.99984 19.2831 9.99984 18.9998V12.9998L4.19984 5.59976C3.94984 5.26642 3.91234 4.91642 4.08734 4.54976C4.26234 4.18309 4.5665 3.99976 4.99984 3.99976H18.9998C19.4332 3.99976 19.7373 4.18309 19.9123 4.54976C20.0873 4.91642 20.0498 5.26642 19.7998 5.59976L13.9998 12.9998V18.9998C13.9998 19.2831 13.904 19.5206 13.7123 19.7123C13.5207 19.9039 13.2832 19.9998 12.9998 19.9998H10.9998Z",
    fill: "#EAD40C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.959f10183077d515df107a9c3653952c.svg";
export { ForwardRef as ReactComponent };